module.exports = __webpack_public_path__ + "img/menu_icon06.5cf82606.png";